export { default } from './stock-bound-skeleton';
